<template>
  <div>
    <bill-appointments-list
      v-if="bill"
      :listTitle="'selectAppointments'"
      :billAppointmentsFullList="items"
      :selectedBillAppointments="bill.providedServices"
      @selectedbillappointmentsupdated="updateSelectedBillAppointments"
      ><slot slot="filters" name="filters"></slot
    ></bill-appointments-list>

    <v-row class="no-gutters justify-space-between">
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          rounded
          block
          :disabled="true"
          >{{ $t("billAppointments.otherAppointments") }}</v-btn
        >
      </v-col>
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          :disabled="!hasBillAppointments"
          depressed
          rounded
          block
          @click="goToBillPage"
          >{{ $t("billAppointments.addToBill") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import BillAppointmentsList from "./BillAppointmentsList";

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  components: {
    BillAppointmentsList
  },
  data() {
    return {
      bill: null
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    hasBillAppointments() {
      return this.bill.providedServices.length > 0;
    }
  },
  methods: {
    initialize() {
      this.bill = cloneDeep(
        this.$store.getters["bills/billDetails"](this.contentType)
      );
    },
    updateSelectedBillAppointments(selectedBillAppointments) {
      this.bill.providedServices = selectedBillAppointments;
    },
    goToBillPage() {
      this.bill.providedServices = orderBy(
        this.bill.providedServices,
        "appointmentId",
        "asc"
      );
      this.$store.commit("bills/setBillDetails", {
        contentType: this.contentType,
        billDetails: this.bill
      });

      this.$router.push({ name: "newBill" });
    }
  }
};
</script>
